module.exports = __webpack_public_path__ + "static/media/dn-seraphim.9ad6b5cf.jpg";